import React from 'react'

const MsjHome = () => {
   return (
      <div className="bg-latitud animated fadeIn">
         <div className="container section center white-text">
            <h6>
            <strong>
               Más de 3.000 empresas ya son parte de Latitud Sur. ¡Te invitamos a
               sumarte!
            </strong>
            </h6>
         </div>
      </div>
   );
}

export default MsjHome